// Миксин бегущей строки для опций селекта.
const MARQUEE_SPEED = 50; // скорость прокрутки текста, px/сек (одинаковая для любой длины)
const MARQUEE_GAP = 24; // отступ («хвост») между копиями текста, px — должен совпадать с padding-right в scss
const MARQUEE_MIN_DURATION = 2.5; // минимальная длительность цикла, сек
const MARQUEE_FALLBACK_INTERVAL = 500; // интервал фолбэк-замера, мс

export default {
  data () {
    return {
      // признак переполнения: бегущая строка включена только при true
      dataMarqueeOverflow: false,
      // длительность одного цикла анимации, сек
      dataMarqueeDuration: 0
    };
  },

  computed: {
    computedMarqueeClass () {
      return {
        'call-select-marquee--run': this.dataMarqueeOverflow
      };
    },

    computedMarqueeStyle () {
      return this.dataMarqueeDuration
        ? { animationDuration: `${this.dataMarqueeDuration}s` }
        : null;
    }
  },

  mounted () {
    this.$_marqueeMeasure();

    const wrap = this.$refs.marqueeWrap;
    if (wrap) {
      // бегущая строка запускается только при наведении:
      // замеряем синхронно (dropdown в этот момент открыт, ширина известна)
      // и применяем анимацию напрямую, не дожидаясь реактивного обновления Vue
      this.$_marqueeOnEnter = () => {
        const inner = this.$refs.marqueeInner;
        if (!inner) {
          return;
        }

        this.$_marqueeMeasure(true);

        if (!this.dataMarqueeOverflow) {
          return;
        }

        // старт с начала текста
        inner.style.animation = 'none';
        inner.getBoundingClientRect(); // принудительный reflow, чтобы сброс применился
        inner.style.animation = '';
        inner.style.animationDuration = `${this.dataMarqueeDuration}s`;
        inner.style.animationPlayState = 'running';
      };
      wrap.addEventListener('mouseenter', this.$_marqueeOnEnter);

      // при уходе возвращаем текст в исходное положение (с начала),
      // а не просто ставим анимацию на паузу
      this.$_marqueeOnLeave = () => {
        const inner = this.$refs.marqueeInner;
        if (!inner) {
          return;
        }

        inner.style.animation = 'none';
        inner.getBoundingClientRect(); // принудительный reflow, чтобы сброс применился
        inner.style.animation = '';
        inner.style.animationDuration = '';
        inner.style.animationPlayState = '';
      };
      wrap.addEventListener('mouseleave', this.$_marqueeOnLeave);
    }

    if (typeof ResizeObserver !== 'undefined') {
      this.$_marqueeObserver = new ResizeObserver(() => {
        this.$_marqueeMeasure();
      });
      this.$_marqueeObserver.observe(this.$refs.marqueeWrap);
    } else {
      // фолбэк для старых браузеров: проверяем, пока не появится реальная ширина
      this.$_marqueeTimer = setInterval(() => this.$_marqueeMeasure(), MARQUEE_FALLBACK_INTERVAL);
    }
  },

  updated () {
    this.$_marqueeMeasure();
  },

  beforeDestroy () {
    const wrap = this.$refs.marqueeWrap;
    if (wrap) {
      if (this.$_marqueeOnEnter) {
        wrap.removeEventListener('mouseenter', this.$_marqueeOnEnter);
        this.$_marqueeOnEnter = null;
      }
      if (this.$_marqueeOnLeave) {
        wrap.removeEventListener('mouseleave', this.$_marqueeOnLeave);
        this.$_marqueeOnLeave = null;
      }
    }
    if (this.$_marqueeObserver) {
      this.$_marqueeObserver.disconnect();
      this.$_marqueeObserver = null;
    }
    if (this.$_marqueeTimer) {
      clearInterval(this.$_marqueeTimer);
      this.$_marqueeTimer = null;
    }
  },

  methods: {
    $_marqueeMeasure (immediate = false) {
      const measure = () => {
        const wrap = this.$refs.marqueeWrap;
        const text = this.$refs.marqueeText;
        if (!wrap || !text) {
          return;
        }

        // контейнер скрыт (dropdown закрыт) — ширины ещё нет, ждём следующего замера;
        // при синхронном замере (hover) контейнер гарантированно виден
        if (!immediate && wrap.clientWidth === 0) {
          return;
        }

        // реальная ширина текста: scrollWidth на inline-элементе ненадёжен
        const textWidth = text.getBoundingClientRect().width;
        const isOverflow = textWidth > wrap.clientWidth + 20;

        this.dataMarqueeOverflow = isOverflow;
        // длительность подбирается по ширине, чтобы скорость движения текста
        // (px/сек) оставалась одинаковой независимо от длины строки
        this.dataMarqueeDuration = isOverflow
          ? Math.max(
            MARQUEE_MIN_DURATION,
            (textWidth + MARQUEE_GAP) / MARQUEE_SPEED
          )
          : 0;

        // первый успешный замер состоялся — фолбэк-таймер больше не нужен
        if (this.$_marqueeTimer) {
          clearInterval(this.$_marqueeTimer);
          this.$_marqueeTimer = null;
        }
      };

      // при наведении замеряем немедленно (дропдаун уже открыт),
      // в остальных случаях — после очередной отрисовки
      if (immediate) {
        measure();
      } else {
        this.$nextTick(measure);
      }
    }
  }
};
